module.exports = __webpack_public_path__ + "img/curva.a844a5dc.svg";